<template>
  <div>
    <el-dialog v-model='dialogVisible' width="500" @open="onDialogOpen" :close-on-click-modal="false">
      <template #header="{ titleId }">
        <div class="my-header">
          <h4 :id="titleId" style="text-align: center;">任务提醒</h4>
        </div>
      </template>
      <p class="title paddingBottom10">{{ teacherName }}老师，您好：</p>
      <p class="title paddingBottom10 indent2">
        我是您的XDF企微助手，感谢您的信赖和使用，为了给您提供稳定的服务，请您在发送任务执行之前，务必确认以下三项前提条件，以确保任务的正确执行🌹🌹🌹</p>
      <el-divider />
      <div class="check_box">
        <el-checkbox v-model="qw_app_vr" size="large">
          <template #default>
            请确保您的【企业微信】应用版本在<span class="hight_light_tip">4.1.8及以上</span>
          </template>
        </el-checkbox>
        <el-checkbox v-model="qw_app_login" size="large">
          <template #default>
            请确保您的【企业微信】应用已经<span class="hight_light_tip">启动</span>并且<span class="hight_light_tip">登录</span>
          </template>
        </el-checkbox>
        <el-checkbox v-model="qw_app_xdf" size="large">
          <template #default>
            请确保您的【企业微信】对应的企业已经切换到【<span class="hight_light_tip">新东方</span>】
          </template>
        </el-checkbox>
      </div>
      <el-divider />
      <ul class="send_tip_box">
        <li class="tip paddingBottom10">
          <el-text size="small" type="warning">请根据任务执行时间，预估您电脑电量是否能支撑任务执行完毕，建议链接电源</el-text><br />
          <el-text size="small" type="warning">预计完成时间：{{ formatRetainTime(sendTime) }}</el-text>
        </li>
        <li class="tip paddingBottom10">
          <el-text size="large" type="danger">任务执行过程中，<b>切勿手动操作电脑</b></el-text>
        </li>

        <li class="tip paddingBottom10">
          <el-text size="large" type="danger">如有特殊情况，请按键盘<b>【ESC】</b>键退出任务</el-text>
        </li>
      </ul>
      <div class="i_know" style="text-align: center;">
        <el-checkbox v-model="i_know_check" @change="IKnowCheckChange" size="small">
          <template #default>
            我已知晓发送前需检查三项勾选，不用再提示了。
          </template>
        </el-checkbox>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="noSend">暂不发送</el-button>
          <el-button type="primary" @click="sureSend" :loading="confirming" :disabled='sendButtonDisable'>
            确认发送
          </el-button>
        </div>
      </template>

    </el-dialog>
    <el-dialog v-model="sending" class="padding100" modal-class="dark_mask" :close-on-click-modal="false"
      :show-close="false" :close-on-press-escape="false" width="600" align-center title="提示" append-to-body>
      <div class="sending_tip_box">
        <img src="https://img.soogif.com/fqLB8PW1gYsNtK2E4FD4AL99LtdnuKIj.gif_s300x0" alt="">
        <h2>任务进行中, <span></span> 请勿操作您的电脑！</h2>
        <h2>如需中断，请按<b>【ESC】</b>键</h2>
      </div>
    </el-dialog>

    <el-dialog v-model="finishSendMessage" class="padding100" modal-class="dark_mask" :close-on-click-modal="false" :show-close="false" :close-on-press-escape="false" width="600" align-center title="" append-to-body>
      <div class="finish_title">发送结果</div>
      <div class="finish_box">
        <div class="box_item">任务名称: {{ sendResult.taskName }}</div>
        <div class="box_item">发送时长: {{ sendResult.sendTimeTotal }}</div>
        <div class="box_item">发送结果: <span class="send_fail" v-if="sendResult.failCount">失败 {{ sendResult.failCount }}人</span> <span v-else>全部成功</span></div>
      </div>
      <div class="finish_button">
        <el-button type="primary" @click="opendetail()" v-if="sendResult.failCount">查看解决方案</el-button>
        <el-button type="primary" @click="opendetail()" v-else>查看发送详情</el-button>
      </div>
    </el-dialog>

    <el-dialog v-model="reporting" class="padding100" modal-class="dark_mask" :close-on-click-modal="false"
      :show-close="false" :close-on-press-escape="false" width="600" align-center title="正在进行结果上报..." append-to-body>
      <el-progress :stroke-width="10" :percentage="reportPercent" status="success" striped striped-flow :duration="25">
        <span>{{ reportPercent }}%</span>
      </el-progress>
    </el-dialog>

  </div>
</template>

<script setup>
import { ref, watch, toRef, computed } from 'vue';
import { getSendTime, sendMsgs } from '@/utils/callingAppApi'
import { onSendResultNotify } from '@/utils/appListenerApi'
import { getResultToShowFromAppResData, transformDataSendToApp } from '@/utils/resolveData.js'
import { ElNotification, ElMessageBox } from 'element-plus';
import { resolveReportDataByStartTime, selfGetStorage, selfSetStorage } from '@/utils/util.js'
import { saveTask, taskContentApi, taskResultReport, taskLogRepot, sendDetailSimpleApi } from '@/api/qwSendMessage';
import { getLatestStudentQwInfo } from '@/api/common.js'
import { useRouter } from 'vue-router';
import { formatTime, getDeviceInfoFromStorage, formatRetainTime } from '@/utils/util';
import { useTaskListStore } from '@/store/taskList.js'
import { useUserInfoStore } from '@/store/userInfo.js'
const reportPercent = ref(0);
const userInfoStore = useUserInfoStore()
const taskListStore = useTaskListStore()
const router = useRouter();
const props = defineProps(['modelValue', 'studentNumber', 'msgNumber', 'saveData', 'resend'])
const emit = defineEmits(['update:modelValue', 'finishSend'])
const sendData = ref([]);
const sendTime = ref(0);
const confirming = ref(false)
const sending = ref(false)
const reporting = ref(false);
const teacherName = userInfoStore.userInfo.nickname;
let sendDataFromBackend = {};

const finishSendMessage = ref(false);
const sendResult = ref({
  // taskName: '课后任务111',
  // sendTimeTotal: '1小时10分',
  // total: '10',
  // sucCount: '10',
  // failCount: '10',
});

const qw_app_vr = ref(false);
const qw_app_login = ref(false);
const qw_app_xdf = ref(false);
const i_know_check = ref(false);
const IKnowCheckChange = (v) => {
  console.log(111, v)
  if (v) {
    selfSetStorage('i_know_check', '1.0')
    qw_app_vr.value = true;
    qw_app_login.value = true;
    qw_app_xdf.value = true;
  } else {
    selfSetStorage('i_know_check', '')
  }
}


const sendButtonDisable = computed(() => {
  return !qw_app_vr.value || !qw_app_login.value || !qw_app_xdf.value;
})
const dialogVisible = computed({
  get: () => props.modelValue,
  set: () => emit('update:modelValue')
})
let currentTaskId = '';
let reportSendResultNum = 0;
let reportSendLogNum = 0;
let sendMsgResultData = {};


watch(() => props.saveData, () => {
  console.log('watch(() => props.saveData,', props.saveData, props.resend)
  if (props.resend) {
    sendData.value = props.saveData;
    return;
  }
  if (!props.saveData.taskName) return;
  sendData.value = transformDataSendToApp(props.saveData)

}, {
  immediate: true
})



const onDialogOpen = () => {
  selfGetStorage('i_know_check').then(v => {
    console.log(8888, v)
    if (v == '1.0') {
      i_know_check.value = true;
      qw_app_vr.value = true;
      qw_app_login.value = true;
      qw_app_xdf.value = true;
    }
  })
  reportSendResultNum = 0;
  reportSendLogNum = 0;
  getSendTime(sendData.value, (res) => {
    console.log('getSendTime(sendData.value res', res)
    sendTime.value = res.time
  })
}
const updateFirstSendReciverName = (newInfoList) => {
  console.log('props.saveData', props.saveData)
  console.log('newInfoList', newInfoList)
  //根据 
  props.saveData.groupSendObjects.forEach(item => {
    item.sendTarget.forEach(target => {
      newInfoList.forEach(item2 => {
        if (item2.studentCode == target.studentCode) {
          target.receiveName = item2[item.sendType != 2 ? 'weChatRemark' : 'weChatGroupName']
          target.wechatBasicInfo = item2.wechatBasicInfo || {};
        }
      })

    })
    if (item.sendType == 0) {
      // 个人群发
      props.saveData.studentMessageDetails.forEach(detailItem => {
        newInfoList.forEach(item2 => {
          if (detailItem.studentCode == item2.studentCode) {
            detailItem.receiveName = item2.weChatRemark
            detailItem.wechatBasicInfo = item2.wechatBasicInfo || {};
          }
        })
      })

    } else if (item.sendType == 2) {
      // 多群群发
      props.saveData.studentMessageDetails.forEach(detailItem => {
        newInfoList.forEach(item2 => {
          if (detailItem.studentCode == item2.studentCode) {
            detailItem.chatGroupName = item2.weChatGroupName
            detailItem.wechatBasicInfo = item2.wechatBasicInfo || {};
          }
        })
      })
    }

  })

}

// 获取初次发送的数据中未绑定关联关系的学员
const judgeEmptyStudentOfFirstSendData = () => {
  let emptyStudentList = [];
  props.saveData.groupSendObjects.forEach(item => {
    item.sendTarget.forEach(student => {
      if (!student.receiveName) {
        emptyStudentList.push(student);
      }
    })
  })
  return emptyStudentList;
}
// 过滤初次发送的数据中未绑定关联关系的学员
const filterEmptyStudentOfFirstSendData = () => {
  props.saveData.groupSendObjects.forEach(item => {
    let notEmptyStudentList = [];
    item.sendTarget.forEach(student => {
      if (student.receiveName) {
        notEmptyStudentList.push(student);
      }
    })
    item.sendTarget = notEmptyStudentList;
  })
  props.saveData.studentMessageDetails = props.saveData.studentMessageDetails.filter(item => item.receiveName);
}

const saveAndSend = () => {
  saveTask({
    ...props.saveData,
    sendTime: formatTime(Date.now())
  }).then((taskId) => {
    currentTaskId = taskId
    taskContentApi(taskId).then(res => {
      confirming.value = false
      // console.log("先保存 在获取之后的数据是", res)
      // console.log("要给APP的数据是：",transformDataSendToApp(res))
      const sendData = transformDataSendToApp(res);
      sending.value = true
      sendDataFromBackend = sendData;
      console.log('sendData',sendData);
      sendMsgs(sendData, (res) => {
        sending.value = false
        console.log('发送结果通知4：', res)
        reportResultAndLog(res.data, {
          data: {
            taskId,
            device: getDeviceInfoFromStorage(),
            content: res.log
          }
        })
      })

    }).catch((err) => {
      ElNotification({
        title: '获取发送数据失败',
        message: err || '系统繁忙',
        type: 'error',
      })
      confirming.value = false
    })
  }).catch(err => {
    confirming.value = false
    window.bonreeJsBridge && window.bonreeJsBridge?.setCustomLog("确认发送执行保存的错误信息：" + JSON.stringify(err));
    ElNotification({
      title: '保存失败',
      message: err || '系统繁忙',
      type: 'error',
    })
  })
}
const firstSend = () => {
  console.log(props.saveData)
  if(!props.saveData.taskName){
    ElNotification({
      title: '警告',
      message: "任务名称不能为空",
      type: 'warning',
    })
    return;
  }
  if (props.saveData.groupSendObjects.some(item => item.sendTarget.length == 0 || item.sendContent.length == 0)) {
    ElNotification({
      title: '警告',
      message: "发送学员和内容不能为空",
      type: 'warning',
    })
    return;
  }
  // // dialogVisible.value = false;
  confirming.value = true
  // 先调用保存 然后再去调用获取
  // let saveDataWithOutReceiveNameSelectList = {
  //   ...props.saveData,
  //   groupSendObjects:
  // }
  let studentCodes = props.saveData.studentMessageDetails.map(item => item.studentCode);
  getLatestStudentQwInfo({ studentCodes: studentCodes }).then(res => {
    updateFirstSendReciverName(res);
    console.log('getLatestStudentQwInfo', props.saveData);
    // 需要过滤掉recieveName为空的学员
    const emptyStudentList = judgeEmptyStudentOfFirstSendData();
    if (emptyStudentList.length) {
      ElMessageBox.confirm(
        `需发送的学员中，${emptyStudentList.map(item => "<b>" + item.studentName + "</b> ")}未绑定相应的微信关系`,
        '警告',
        {
          confirmButtonText: '自动移除这些学员后发送',
          cancelButtonText: '重新编辑',
          type: 'warning',
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          filterEmptyStudentOfFirstSendData();
          if (props.saveData.studentMessageDetails.length == 0) {
            ElNotification({
              title: '警告',
              message: '本次任务所需发送目标为空。',
              type: 'warning',
            })
            confirming.value = false;
            return;
          }
          saveAndSend();
        })
        .catch(() => {
          confirming.value = false;
          dialogVisible.value = false;
        })
    } else {
      saveAndSend();
    }

  }).catch(err => {
    confirming.value = false;
    ElNotification({
      title: '失败',
      message: '获取学员最新微信信息失败',
      type: 'error',
    })
  })
}
const editToReSend = () => {
  confirming.value = true
  currentTaskId = sendData.value.id;
  let studentCodes = sendData.value.chats.map(item => item.studentCode);

  console.log('sendData.value', sendData.value)
  getLatestStudentQwInfo({ studentCodes: studentCodes ,taskId:currentTaskId}).then(res => {
    sendData.value.chats.forEach(item => {
      res.forEach(item2 => {
        if (item2.studentCode == item.studentCode) {
          item.chat_name = item.chat_type == 2 ? item2.weChatGroupName : item2.weChatRemark;
          item.studentCode = undefined;
          item.wechatBasicInfo = item2.wechatBasicInfo || {};
        }
      })
    })

    console.log('getLatestStudentQwInfo', res)
    // 获取空的消息发送
    let emptyChatOfEditToSend = [];
    let noEmptyChatOfEditToSend = []
    sendData.value.chats.forEach(chat => {
      if (chat.chat_name) {
        noEmptyChatOfEditToSend.push(chat)
      } else {
        emptyChatOfEditToSend.push(chat)
      }
    })
    if (emptyChatOfEditToSend.length) {
      ElMessageBox.confirm(
        `需发送的学员中，${emptyChatOfEditToSend.map(item => "<b>" + item.student_name + "</b> ")}未绑定相应的微信关系`,
        '警告',
        {
          confirmButtonText: '自动移除这些学员后发送',
          cancelButtonText: '重新编辑',
          type: 'warning',
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          sendData.value.chats = noEmptyChatOfEditToSend;
          if (noEmptyChatOfEditToSend.length == 0) {
            ElNotification({
              title: '警告',
              message: '本次任务所需发送目标为空。',
              type: 'warning',
            })
            confirming.value = false;
            return;
          }
          sending.value = true
          sendDataFromBackend = sendData.value;
          console.log('(sendData.value',sendData.value);
          sendMsgs(sendData.value, (res) => {
            confirming.value = false
            sending.value = false
            console.log('发送结果通知：5', res)
            reportResultAndLog(res.data, {
              data: {
                taskId: sendData.value.id,
                device: getDeviceInfoFromStorage(),
                content: res.log

              }
            })
          })
        })
        .catch(() => {
          dialogVisible.value = false;
          confirming.value = false;
        })
    } else {
      sending.value = true
      sendDataFromBackend = sendData.value;
      console.log('sendData',sendData.value);
      sendMsgs(sendData.value, (res) => {
        confirming.value = false
        sending.value = false
        console.log('发送结果通知：6', res)
        reportResultAndLog(res.data, {
          data: {
            taskId: sendData.value.id,
            device: getDeviceInfoFromStorage(),
            content: res.log

          }
        })
      })
    }
  }).catch(err => {
    confirming.value = false;
    ElNotification({
      title: '失败',
      message: '获取学员最新微信信息失败',
      type: 'error',
    })
  })
}

const sureSend = () => {
  if (props.resend) {
    editToReSend()
  } else {
    firstSend()
  }
}
const noSend = () => {
  dialogVisible.value = false;
}

let reportTimer = null;
const startReportPercent = () => {
  reportPercent.value = 0;
  let num = Math.round(Math.random() * 19 + 80) // 80% - 99%
  let timer = setInterval(() => {
    if (reportPercent.value <= (num - 1)) {
      reportPercent.value += 1;
    } else {
      reportPercent.value = num;
      clearInterval(timer);
    }
  }, 200)
  return timer;
}
const stopReportPercent = () => {
  clearInterval(reportTimer);
}
const reportResultAndLog = (reportData, logData) => {
  reporting.value = true;
  reportTimer = startReportPercent();

  reportData = resolveReportDataByStartTime(sendDataFromBackend,reportData)   //对比要发送的数据和要上报的数据， 决定哪些数据需要更新
  if (reportData && logData) {
    Promise.allSettled([reportSendResult(reportData), reportSendLog(logData)]).then(res => {
      let [resultRes, logRes] = res;
      if (resultRes.status != 'rejected' && logRes.status != 'rejected') {
        // 都成功
        finishiSendMsg();
      } else if (resultRes.status == 'rejected' && logRes.status == 'rejected') {
        // 都失败
        window.bonreeJsBridge && window.bonreeJsBridge?.setCustomLog("上报结果接口的错误信息：" + JSON.stringify(resultRes.reason));
        window.bonreeJsBridge && window.bonreeJsBridge?.setCustomLog("上报日志的错误信息：" + JSON.stringify(logRes.reason));
        reporting.value = false;
        stopReportPercent()
        ElMessageBox.alert('发送任务执行结果上报失败', '提示', {
          confirmButtonText: '重新上报',
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          callback: () => {
            reportResultAndLog(reportData, logData)
          },
        })

      } else if (resultRes.status == 'rejected') {
        // 结果上报失败
        window.bonreeJsBridge && window.bonreeJsBridge?.setCustomLog("上报结果接口的错误信息：" + JSON.stringify(resultRes.reason));
        reporting.value = false;
        stopReportPercent()

        if (reportSendResultNum >= 3) {
          // 结果上报重试3次都失败 就不拦截了
          finishiSendMsg('taskResultReport ctach');
          return;
        }
        reportSendResultNum++;
        ElMessageBox.alert('为了避免任务重复发送，保证执行结果正常记录，请您点击【重新上报】，完成本次任务~', '提示', {
          confirmButtonText: '重新上报',
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          callback: () => {
            reportResultAndLog(reportData)
          },
        })
      } else if (logRes.status == 'rejected') {
        // 日志上报失败
        window.bonreeJsBridge && window.bonreeJsBridge?.setCustomLog("上报日志的错误信息：" + JSON.stringify(logRes.reason));
        reporting.value = false;
        stopReportPercent()
        if (reportSendLogNum >= 3) {
          // 结果上报重试3次都失败 就不拦截了
          finishiSendMsg('taskLogRepot catch');
          return;
        }
        reportSendLogNum++;
        ElMessageBox.alert('为了测试期间采集数据，请您配合上报日志，点击【重新上报】完成本次任务~', '提示', {
          confirmButtonText: '重新上报',
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          callback: () => {
            // reportSendLog(logData)
            reportResultAndLog(undefined, logData)
          },
        })
      }
    })
    return;
  }
  if (reportData) {
    // 结果重新上报
    reportSendResult(reportData).then(res => {
      finishiSendMsg();
    }).catch(err => {
      // 结果上报失败
      window.bonreeJsBridge && window.bonreeJsBridge?.setCustomLog("上报结果接口的错误信息：" + JSON.stringify(resultRes.reason));
      reporting.value = false;
      stopReportPercent()
      if (reportSendResultNum >= 3) {
        // 结果上报重试3次都失败 就不拦截了
        finishiSendMsg('taskResultReport ctach');
        return;
      }
      reportSendResultNum++;
      ElMessageBox.alert('为了避免任务重复发送，保证执行结果正常记录，请您点击【重新上报】，完成本次任务~', '提示', {
        confirmButtonText: '重新上报',
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        callback: () => {
          // reportSendResult(reportData)
          reportResultAndLog(reportData)
        },
      })
    })
  }
  if (logData) {
    // 日志重新上报
    reportSendLog(logData).then(res => {
      finishiSendMsg();
    }).catch(err => {
      // 日志上报失败
      window.bonreeJsBridge && window.bonreeJsBridge?.setCustomLog("上报日志的错误信息：" + JSON.stringify(logRes.reason));
      reporting.value = false;
      stopReportPercent()
      if (reportSendLogNum >= 3) {
        // 结果上报重试3次都失败 就不拦截了
        finishiSendMsg('taskLogRepot catch');
        return;
      }
      reportSendLogNum++;
      ElMessageBox.alert('为了测试期间采集数据，请您配合上报日志，点击【重新上报】完成本次任务~', '提示', {
        confirmButtonText: '重新上报',
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        callback: () => {
          // reportSendLog(logData)
          reportResultAndLog(undefined, logData)
        },
      })
    })
  }
}


const reportSendResult = (reportData) => {
  sendMsgResultData = reportData;
  return taskResultReport(reportData)
}
const reportSendLog = (logData) => {
  return taskLogRepot(logData)
}
const getTimeDifference = (start, end)=> {
  let sendTotlaTime = ''
  start = start.replace(/-/g,'/');
  end = end.replace(/-/g,'/');
  const startTime = new Date(start);
  const endTime = new Date(end);
  const timeDiff = Math.abs(endTime.getTime() - startTime.getTime());
  const hours = Math.floor(timeDiff / (1000 * 60 * 60));
  const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);
  hours && (sendTotlaTime += `${hours}小时`)
  sendTotlaTime += `${minutes}分钟${seconds}秒`
  return sendTotlaTime;
  // return { hours, minutes, seconds };
}
const finishiSendMsg = (log) => {
  stopReportPercent();
  reportPercent.value = 100;
  setTimeout(async () => {
    // 这个定时器是给进度条服务的
    reporting.value = false;
    // console.log('sendMsgResultData', sendMsgResultData)
    taskListStore.setCurrentTaskTabId(currentTaskId)
    emit('finishSend');
    let res = {};
    try {
      res = await sendDetailSimpleApi(currentTaskId);
    } catch (error) {
      res = getResultToShowFromAppResData(sendMsgResultData)
    }
    
    console.log('res---------', res);
    sendResult.value.taskName = res.taskName;
    sendResult.value.sendTimeTotal = getTimeDifference(res.startTime, res.endTime);
    sendResult.value.total = res.total;
    sendResult.value.sucCount = res.sucCount;
    sendResult.value.failCount = res.failCount + res.unSendCount;;
    dialogVisible.value = false;
    finishSendMessage.value= true;
  }, 1000)
}

// setTimeout(()=>{
//   finishiSendMsg()
// , 3000})
const opendetail = () =>{
  if (props.resend) {
    finishSendMessage.value = false;
    taskListStore.updateTaskList();
  } else {
    router.back()
  }
  
}
onSendResultNotify((data) => {
  console.log("APP主动调用给的数据是：", data);
})



</script>

<style lang="less" scoped>
.title {
  font-weight: 600;
}

.send_tip_box {
  // list-style-position: inside;
  list-style: none;

  .tip {}
}

.dialog-footer {
  text-align: center;
}

.sending_tip_box {
  height: 200px;
  margin: auto;

  img {
    display: block;
    width: 50%;
    margin: auto;
  }

  h2 {
    text-align: center;
    margin-top: 30px;
  }
}

.dark_mask {
  background: rgba(245, 20, 20, 0.8);
  opacity: 1;
}

.indent2 {
  text-indent: 2em;
}

.hight_light_tip {
  color: red;
  font-size: larger;
}

:deep(.el-checkbox__input.is-checked+.el-checkbox__label) {
  color: var(--el-checkbox-text-color);
}
.finish_title{
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  color: #000;
  margin-bottom: 30px;
}
.finish_box{
  padding: 0 40px;
  .box_item{
    margin-bottom: 20px;
    .send_fail{
      color: red;
    }
  }
}

.finish_button{
  margin: 30px auto;
  text-align: center;
}
</style>